import React, {useMemo} from 'react';
import cn from 'classnames';

import Video from 'brandComponents/core/Video';

import {IContentfulVideoProps} from './IContentfulVideoProps';

// eslint-disable-next-line no-restricted-imports
import './ContentfulVideo.scss';

// The aspect ratio of the provider is fetched by `Video`, below its `NonCriticalBoundary` (`nonCritical`: a CMS module
// is streamed after the shell when the provider is slow).
const ContentfulVideo = (props: IContentfulVideoProps) => {
	const videoConfig = useMemo(() => ({
		showControls: props.showControls,
		autoplay: props.autoplay,
		muted: props.muted,
		noSkin: props.noSkin,
		loop: props.loop
	}), [props.showControls, props.autoplay, props.muted, props.noSkin, props.loop]);

	const controlsConfig = useMemo(() => {
		let controlsConfig = null;

		if (props.showControls && props.controlsConfig) {
			controlsConfig = {};

			controlsConfig.playButton = props.controlsConfig.playButton &&
				{
					playIcon: props.controlsConfig?.playButton?.playIcon || '',
					pauseIcon: props.controlsConfig?.playButton?.pauseIcon || '',
					height: props.controlsConfig?.playButton?.height || 25,
					width: props.controlsConfig?.playButton?.width || 25,
				};

			controlsConfig.muteButton = props.controlsConfig.muteButton &&
				{
					mutedIcon: props.controlsConfig?.muteButton?.mutedIcon || '',
					unmutedIcon: props.controlsConfig?.muteButton?.unmutedIcon || '',
					height: props.controlsConfig?.playButton?.height || 25,
					width: props.controlsConfig?.playButton?.width || 25,
				};
		}

		return controlsConfig;
	}, [props.showControls, props.controlsConfig, props.showPlayButton, props.showMuteButton]);

	return (
		<div
			className={cn(
				'cf-video',
				{
					['adapt-to-container']: props.adaptToContainer
				}
			)}
		>
			<Video
				provider={props.provider}
				videoId={props.videoId}
				mobileVideoId={props.mobileVideoId}
				videoConfig={videoConfig}
				controlsConfig={controlsConfig}
				thumbnail={props.thumbnail}
				thumbnailMobile={props.thumbnailMobile}
				changeBreakpoint="medium"
				aspectRatio={props.aspectRatio}
				aspectRatioMobile={props.aspectRatioMobile}
				nonCritical
			/>
		</div>
	);
};

export default ContentfulVideo;
